import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const getPageTitle = (pathname) => {
	if (pathname.startsWith('/admin/users/') && pathname.length > '/admin/users'.length + 1) return 'User Detail';
	if (pathname.startsWith('/admin/pet-management/') && pathname.length > '/admin/pet-management'.length + 1) return 'Pet detail';
	return {
		'/admin/shelters': 'Shelter',
		'/admin/dashboard': 'Dashboard',
		'/admin/subscription': 'Subscription',
		'/admin/users': 'User Management',
		'/admin/pet-management': 'Pet management',
		'/admin/settings': 'Setting',
	}[pathname] || 'Shelter';
};

const isUserDetailPage = (pathname) =>
	pathname.startsWith('/admin/users/') && pathname.length > '/admin/users'.length + 1;

const isPetDetailPage = (pathname) =>
	pathname.startsWith('/admin/pet-management/') && pathname.length > '/admin/pet-management'.length + 1;

const PAGE_SUBTITLES = {
	'/admin/shelters': 'Overview',
	'/admin/dashboard': 'Overview',
	'/admin/subscription': 'Overview',
	'/admin/users': 'Overview',
	'/admin/pet-management': 'Overview',
	'/admin/settings': 'Overview',
};

const Header = ({ onMenuClick }) => {
	const location = useLocation();
	const userDetail = JSON.parse(localStorage.getItem('userDetail') || '{}');
	const userName = userDetail?.name || userDetail?.first_name || 'John';
	const pageTitle = getPageTitle(location.pathname);
	const pageSubtitle = PAGE_SUBTITLES[location.pathname] ?? (isPetDetailPage(location.pathname) ? 'Overview' : 'Overview');
	const showBreadcrumb = isUserDetailPage(location.pathname);
	const showPetDetailBreadcrumb = isPetDetailPage(location.pathname);

	return (
		<header>
			<div className="top-nav">
				<div className="nav-inner">
					<div className="header-left">
						{onMenuClick && (
							<button
								type="button"
								className="header-hamburger"
								onClick={onMenuClick}
								aria-label="Open menu"
							>
								<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<line x1="3" y1="6" x2="21" y2="6" />
									<line x1="3" y1="12" x2="21" y2="12" />
									<line x1="3" y1="18" x2="21" y2="18" />
								</svg>
							</button>
						)}
						<div className="header-title-block">
							{showBreadcrumb ? (
								<>
									<h1 className="header-page-title header-breadcrumb" aria-label="Breadcrumb">
										<Link to="/admin/users" className="header-breadcrumb-link">User management</Link>
										<span className="header-breadcrumb-sep">&nbsp;&gt;&nbsp;</span>
										<span className="header-breadcrumb-current">User Detail</span>
									</h1>
									<p className="header-page-subtitle header-breadcrumb-overview">Overview</p>
								</>
							) : showPetDetailBreadcrumb ? (
								<>
									<h1 className="header-page-title header-breadcrumb" aria-label="Breadcrumb">
										<Link to="/admin/pet-management" className="header-breadcrumb-link">Pet management</Link>
										<span className="header-breadcrumb-sep">&nbsp;&gt;&nbsp;</span>
										<span className="header-breadcrumb-current">Pet detail</span>
									</h1>
									<p className="header-page-subtitle header-breadcrumb-overview">Overview</p>
								</>
							) : (
								<>
									<h1 className="header-page-title">{pageTitle}</h1>
									<p className="header-page-subtitle">{pageSubtitle}</p>
								</>
							)}
						</div>
					</div>
					<div className="header-right">
						<div className="user-greeting">
							<span className="greeting-text">Hello <span className="greeting-name">{userName}</span>!</span>
							<span className="greeting-emoji">👋</span>
						</div>
						<div className="user-avatar">
							<img src={window.getPublicUrl('/assets/images/dummy-profile.jpg')} alt="User" />
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};
export default Header;
